import { DataSource, Layout } from "@mcleod/components";
import { AgenciesWithPrimary } from "../../../general/src/AgenciesWithPrimary";

export abstract class AutogenLayoutCarrierUsers extends Layout {
    agenciesWithPrimary: AgenciesWithPrimary;
    sourceAgencyLink: DataSource;
    sourceCarrier: DataSource;
}
